<div class="spinner-wrap" *ngIf="(spinnerService.isLoading | async) as isLoading">
    <span class="loader"></span>
</div>
